export default (el: HTMLElement) => {
	const logo = document.getElementById('siteheader_logo')
	const logoWhite = document.getElementById('siteheader_logo_white')
	const menuToggles = Array.from(el.querySelectorAll('[data-menu-toggle]')) ?? []
	const navigationContainer = el.querySelector('[data-navigation-container]')
	const keyvisual = document.getElementById('keyvisual_container')
	let menuIsHidden = true
	const navigationClassSets = {
		offcanvasVisible: ['!left-0'],
	}

	menuToggles.forEach((toggle) => {
		toggle.addEventListener('click', () => {
			navigationContainer?.classList.add(...navigationClassSets.offcanvasVisible)
			if (menuIsHidden) {
				navigationContainer?.classList.add(...navigationClassSets.offcanvasVisible)
				menuIsHidden = !menuIsHidden
			} else {
				navigationContainer?.classList.remove(...navigationClassSets.offcanvasVisible)
				menuIsHidden = !menuIsHidden
			}
		})
	})

	if (window.matchMedia('screen and (max-width: 1023px)').matches) {
		window.addEventListener(
			'scroll',
			() => {
				const offset = window.scrollY

				const classSets = {
					default: ['bg-transparent', 'text-white'],
					fixed: ['bg-white', 'text-brand', 'shadow', 'py-4', 'text-brand'],
					logo: ['hidden'],
					logoWhite: ['hidden'],
				}

				if (
					offset >
					(keyvisual ? keyvisual.clientHeight - 200 : (window.innerHeight / 3) * 2)
				) {
					el.classList.remove(...classSets.default)
					el.classList.add(...classSets.fixed)
					logo?.classList.remove(...classSets.logo)
					logoWhite?.classList.add(...classSets.logoWhite)
				} else {
					el.classList.remove(...classSets.fixed)
					el.classList.add(...classSets.default)
					logo?.classList.add(...classSets.logo)
					logoWhite?.classList.remove(...classSets.logoWhite)
				}
			},
			{ passive: true }
		)
	}
}
